export default "__VITE_ASSET__QgpgCEoT__"